import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles.css'
import './assets/list-pagination.css'
import './assets/experience-improvements.css'
import './assets/network-training.css'
import './assets/network-workbench.css'
import './assets/network-modules.css'
import './assets/network-scores.css'
import './assets/policy-custom.css'
import './assets/experiment-management.css'
import './assets/report-management.css'
import './assets/student-reports.css'
import './assets/notifications.css'
import './assets/operation-logs.css'
import './assets/map-editor.css'
import './assets/login.css'
import './assets/platform-navigation.css'
import './assets/message-center.css'
import './assets/message-box.css'
import OperationMessage from './components/OperationMessage.vue'
import message from './services/message'
import messageBox from './services/messageBox'

Vue.config.productionTip = false
Vue.component('operation-message', OperationMessage)
Vue.prototype.$message = message
Vue.prototype.$messageBox = messageBox

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
